import { Store } from '@reduxjs/toolkit';

import { PKG } from '../analytics/analyticsConsts';
import { API_CONFIG, RequestConfig, RequestName } from '../api/api.types';
import { ResponseCode } from '../api/http/httpConsts';
import { ANALYTICS } from '../firebase/firebase';

export interface ApiRequest {
  urlSuffix?: string;
  config: RequestConfig;
  token?: string;
  headers?: { [key: string]: string };
  body?: object;
}

export interface ApiResponse {
  data: {
    headers?: Headers;
    body: {
      code?: string;
    };
  };
  status: ResponseCode;
  message?: string;
}

export function emptyApiResponse(): ApiResponse {
  return {
    data: {
      body: {},
    },
    status: ResponseCode.HTTP_ERROR,
    message: '',
  };
}

// TODO: add tests
const constructErrorDetails = (
  apiName: RequestName,
  obj: ApiResponse,
  reason?: string
) => ({
  status: obj && obj.status ? obj.status : 'No status',
  message: obj && obj.message ? obj.message : 'No error message',
  url: API_CONFIG[apiName]?.baseUrl || 'No url',
  reason: reason || undefined,
});

export function handleApiError(
  apiName: RequestName,
  obj: ApiResponse,
  reason?: string
): void {
  const errorDetails = constructErrorDetails(apiName, obj, reason);

  ANALYTICS.funcError(PKG, apiName, JSON.stringify(errorDetails));
}

export type Handler = Partial<
  Record<
    ResponseCode,
    (store: Store, response: ApiResponse, params?: any) => void
  >
>;

// takes a response code, a mapping of response codes to handlers, and a generic error handler
// handlers must be able to take store, response, and optional params
export function getHandler(
  responseStatus: ResponseCode,
  handlers: Partial<Handler>,
  genericError: (store: Store, response: ApiResponse, params?: any) => void
): (store: Store, response: ApiResponse, params?: any) => void {
  return (store: Store, response: ApiResponse, params?: any) => {
    (handlers[responseStatus] || genericError)(store, response, params);
  };
}
